export const API_PATH_ApiAppPresetPut = '/services/app/presets/apiAppPresetPut';
